var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5084 8.0158L21.4991 13.3197L21.4897 18.6237L21.0533 17.3924C21.0532 17.392 21.0526 17.3904 21.0525 17.39L20.4886 29.1979C21.043 30.7636 21.34 31.5994 21.3434 31.6027C21.3477 31.6071 21.6637 31.6261 22.0455 31.6451C23.2022 31.7025 24.6357 31.8255 25.7231 31.9606C25.9749 31.9919 26.1916 32.0079 26.2046 31.9962C26.2177 31.9845 26.2248 26.5841 26.2204 19.9954L26.2125 8.0158H21.5084ZM13 8.00002V19.9917C13 26.5872 13.0065 31.9899 13.0144 31.9978C13.0223 32.0057 13.4307 31.9672 13.922 31.9121C14.4133 31.8571 15.0924 31.7887 15.431 31.7601C15.9503 31.7163 17.5008 31.6166 17.6803 31.6155C17.7325 31.6151 17.7359 31.3457 17.7434 26.5363L17.7514 21.4574L18.1266 22.5189C18.1846 22.6829 18.2027 22.7342 18.2592 22.894L18.823 11.0889C18.7035 10.7512 18.7661 10.9285 18.6293 10.5415C18.1686 9.23918 17.7778 8.13459 17.7607 8.08684L17.7295 8.00002H13Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 0.310123
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.00002V14.7313L17.7419 27.3098C17.7424 27.0215 17.7429 26.8658 17.7434 26.5363L17.7514 21.4574L18.1266 22.5189C20.2148 28.4279 21.3368 31.5961 21.3434 31.6027C21.3477 31.6071 21.6637 31.6261 22.0455 31.6451C23.2022 31.7025 24.6357 31.8255 25.7231 31.9606C25.9749 31.9919 26.1916 32.0079 26.2046 31.9962C26.2136 31.9882 26.2194 29.3402 26.221 25.6047L21.5013 12.0357L21.4991 13.3197L21.4897 18.6237L21.0533 17.3924C20.6269 16.1893 20.3422 15.3847 18.6293 10.5415C18.1686 9.23918 17.7778 8.13459 17.7607 8.08684L17.7295 8.00002H13Z",
    fill: "url(#paint0_radial_896_32032)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8L17.7513 21.4635V21.4574L18.1265 22.5189C20.2147 28.4278 21.3367 31.5961 21.3433 31.6027C21.3476 31.607 21.6636 31.6261 22.0454 31.645C23.2021 31.7024 24.6356 31.8254 25.723 31.9606C25.9735 31.9917 26.1891 32.0077 26.2041 31.9963L21.4896 18.6212V18.6236L21.0532 17.3924C20.6268 16.1893 20.3421 15.3847 18.6292 10.5415C18.1686 9.23916 17.7777 8.13457 17.7606 8.08682L17.7294 8L13 8Z",
    fill: "#E50914"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5084 8.0158L21.4991 13.3197L21.4897 18.6237L21.0533 17.3924C21.0532 17.392 21.0526 17.3904 21.0525 17.39L20.4886 29.1979C21.043 30.7636 21.34 31.5994 21.3434 31.6027C21.3477 31.6071 21.6637 31.6261 22.0455 31.6451C23.2022 31.7025 24.6357 31.8255 25.7231 31.9606C25.9749 31.9919 26.1916 32.0079 26.2046 31.9962C26.2177 31.9845 26.2248 26.5841 26.2204 19.9954L26.2125 8.0158H21.5084ZM13 8.00002V19.9917C13 26.5872 13.0065 31.9899 13.0144 31.9978C13.0223 32.0057 13.4307 31.9672 13.922 31.9121C14.4133 31.8571 15.0924 31.7887 15.431 31.7601C15.9503 31.7163 17.5008 31.6166 17.6803 31.6155C17.7325 31.6151 17.7359 31.3457 17.7434 26.5363L17.7514 21.4574L18.1266 22.5189C18.1846 22.6829 18.2027 22.7342 18.2592 22.894L18.823 11.0889C18.7035 10.7512 18.7661 10.9285 18.6293 10.5415C18.1686 9.23918 17.7778 8.13459 17.7607 8.08684L17.7295 8.00002H13Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 0.310123
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.00002V14.7313L17.7419 27.3098C17.7424 27.0215 17.7429 26.8658 17.7434 26.5363L17.7514 21.4574L18.1266 22.5189C20.2148 28.4279 21.3368 31.5961 21.3434 31.6027C21.3477 31.6071 21.6637 31.6261 22.0455 31.6451C23.2022 31.7025 24.6357 31.8255 25.7231 31.9606C25.9749 31.9919 26.1916 32.0079 26.2046 31.9962C26.2136 31.9882 26.2194 29.3402 26.221 25.6047L21.5013 12.0357L21.4991 13.3197L21.4897 18.6237L21.0533 17.3924C20.6269 16.1893 20.3422 15.3847 18.6293 10.5415C18.1686 9.23918 17.7778 8.13459 17.7607 8.08684L17.7295 8.00002H13Z",
    fill: "url(#paint1_radial_896_32032)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8L17.7513 21.4635V21.4574L18.1265 22.5189C20.2147 28.4278 21.3367 31.5961 21.3433 31.6027C21.3476 31.607 21.6636 31.6261 22.0454 31.645C23.2021 31.7024 24.6356 31.8254 25.723 31.9606C25.9735 31.9917 26.1891 32.0077 26.2041 31.9963L21.4896 18.6212V18.6236L21.0532 17.3924C20.6268 16.1893 20.3421 15.3847 18.6292 10.5415C18.1686 9.23916 17.7777 8.13457 17.7606 8.08682L17.7294 8L13 8Z",
    fill: "#E50914"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_896_32032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3909 19.8605) rotate(-19.0977) scale(2.99662 109.763)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_896_32032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3909 19.8605) rotate(-19.0977) scale(2.99662 109.763)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer6);
export default __webpack_public_path__ + "static/media/offer_6.3b0175dee41ee18ea2fcb220b8472978.svg";
export { ForwardRef as ReactComponent };